import { WhatToPrint } from "./types";
export function shouldPrintImages(what_to_print: WhatToPrint) : boolean {
  return ["print-selected","print-it-all"].includes(what_to_print);
}
